module.exports = __webpack_public_path__ + "media/images/lounge-63b69a926bebc07c28ba56da269dcbd4.svg";